// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "shift4-frontend-app-shell." + {"12":"7750c947ce1e64bfab9f","777":"a9190f91bf02860a73c0"}[chunkId] + ".js";
};